import { useQuery } from '@tanstack/react-query';
import { IDriveContent } from 'src/@types/drive';
import { DriveRequests } from 'src/requests/drive';
import { QueryKey } from 'src/utils/react-query';

export const useSearchContentQuery = (q: string) => {
  const queryKey = [QueryKey.DRIVE, 'Search', q];
  const { data: driveSearchContents, isLoading } = useQuery<IDriveContent[]>(
    queryKey,
    () => DriveRequests.searchContent(q),
    {
      enabled: !!q,
    },
  );
  return {
    driveSearchContents,
    isSearchDriveContentLoading: isLoading,
  };
};
